export default __webpack_public_path__ + "static/media/sb-ICO-08.db09c5a5.webp";